import * as yup from "yup";

const CUSTOMER_EMAIL_SCHEMA = yup.object().shape({
  email: yup
    .string()
    .matches(
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
      "invalid",
    ),
});

export function isValidCustomerEmail(email) {
  try {
    CUSTOMER_EMAIL_SCHEMA.validateSync({ email: String(email || "").trim() });
    return true;
  } catch {
    return false;
  }
}
